import { ReactNode } from 'react';
import dynamic from 'next/dynamic';

import { Props } from './TableList';

export const TableList = dynamic(() => import('./TableList'), { ssr: false }) as <I>(props: Props<I>) => ReactNode;
